<div class="flex flex-col lg:flex-row min-h-screen w-full">
  <!-- Left Side - Hidden on mobile/tablet, shown on large screens and up -->
  <div class="hidden lg:flex lg:w-1/2 relative overflow-hidden">
    <div class="absolute inset-0 bg-[#016934] z-0"></div>
    <div class="absolute inset-0 z-1">
      <img
        src="/assets/images/background/bg.png"
        alt=""
        class="w-full h-full object-cover opacity-30"
      />
    </div>
    <div class="relative z-10 flex items-center h-full p-8 xl:p-12">
      <div class="max-w-lg">
        <h1 class="text-white text-4xl xl:text-6xl font-bold leading-tight">
          Connexion à l'espace Admin
        </h1>
        <div class="w-24 h-1 bg-[#F39200] my-6"></div>
        <p class="text-white text-xl xl:text-3xl leading-relaxed">
          Accédez à votre compte pour gérer efficacement vos réunions
        </p>
      </div>
    </div>
  </div>

  <!-- Right Side - Full width on mobile/tablet, half width on large screens -->
  <div class="w-full lg:w-1/2 bg-white flex flex-col justify-between min-h-screen">
    <!-- Header for mobile/tablet -->
    <!-- <div class="lg:hidden bg-[#016934] text-white text-center py-8 px-6">
      <h1 class="text-3xl md:text-4xl font-bold">ONECI Admin</h1>
      <p class="text-base md:text-lg mt-3 opacity-90">Connexion à votre espace</p>
    </div> -->

    <!-- Main Content -->
    <div class="flex flex-col items-center justify-center flex-grow p-8 sm:p-10 lg:p-12">
      <div class="w-full max-w-lg">
        <!-- Logo -->
        <div class="flex justify-center mb-10">
          <img src="/assets/images/logo/oneci_logo.svg" alt="ONECI Logo" class="h-20 md:h-24" />
        </div>

        <!-- Welcome Text -->
        <div class="text-center mb-10">
          <h2 class="text-[#016934] text-2xl md:text-3xl font-bold mb-6">Bienvenue !</h2>
          <p class="text-[#016934] text-lg md:text-xl px-4 leading-relaxed">
            Veuillez saisir vos identifiants pour accéder à votre compte
          </p>
        </div>

        <!-- Login Form -->
        <form [formGroup]="signInForm" (ngSubmit)="onSubmit()" class="space-y-8">
          <!-- Email Field -->
          <div class="form-group">
            <label for="email" class="block mb-3 text-base md:text-lg font-medium text-gray-700"
              >Identifiant</label
            >
            <!-- <input
              type="text"
              id="email"
              formControlName="email"
              [ngClass]="{
                'border-red-500 focus:ring-red-500': f['email'].invalid && (f['email'].touched || f['email'].dirty),
                'border-green-500 focus:ring-green-500': f['email'].valid && (f['email'].touched || f['email'].dirty),
                'border-gray-300 focus:ring-[#F39200]': f['email'].untouched && f['email'].pristine
              }"
              placeholder="Votre email"
              class="w-full py-4 px-5 border rounded-lg text-base md:text-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all"
            /> -->
            <input
              type="text"
              id="email"
              formControlName="email"
              [ngClass]="{
                'border-red-500 focus:ring-red-500':
                  f['email'].invalid && (f['email'].touched || f['email'].dirty),
                'border-green-500 focus:ring-green-500':
                  f['email'].valid && (f['email'].touched || f['email'].dirty),
                'border-gray-300 focus:ring-[#F39200]': f['email'].untouched && f['email'].pristine
              }"
              placeholder="Votre email"
              class="w-full py-4 px-5 border rounded-lg text-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all"
            />
            <div
              *ngIf="f['email'].invalid && (f['email'].touched || f['email'].dirty)"
              class="text-red-500 text-sm mt-2"
            >
              <span *ngIf="f['email'].errors?.['required']">L'email est requis</span>
              <span *ngIf="f['email'].errors?.['email'] && !f['email'].errors?.['required']"
                >Email invalide</span
              >
            </div>
          </div>

          <!-- Password Field -->
          <div class="form-group">
            <label for="password" class="block mb-3 text-base md:text-lg font-medium text-gray-700"
              >Mot de passe</label
            >
            <div class="relative">
              <!-- <input
                [type]="hidePrincipalPassword ? 'text': 'password'"
                id="password"
                formControlName="password"
                [ngClass]="{
                  'border-red-500 focus:ring-red-500': f['password'].invalid && (f['password'].touched || f['password'].dirty),
                  'border-green-500 focus:ring-green-500': f['password'].valid && (f['password'].touched || f['password'].dirty),
                  'border-gray-300 focus:ring-[#F39200]': f['password'].untouched && f['password'].pristine
                }"
                placeholder="Votre mot de passe"
                class="w-full py-4 px-5 pr-14 border rounded-lg text-base md:text-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all"
              /> -->
              <input
                [type]="hidePrincipalPassword ? 'text' : 'password'"
                id="password"
                formControlName="password"
                [ngClass]="{
                  'border-red-500 focus:ring-red-500':
                    f['password'].invalid && (f['password'].touched || f['password'].dirty),
                  'border-green-500 focus:ring-green-500':
                    f['password'].valid && (f['password'].touched || f['password'].dirty),
                  'border-gray-300 focus:ring-[#F39200]':
                    f['password'].untouched && f['password'].pristine
                }"
                placeholder="Votre mot de passe"
                class="w-full py-4 px-5 pr-14 border rounded-lg text-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all"
              />
              <button
                type="button"
                class="absolute inset-y-0 right-4 flex items-center text-gray-600 hover:text-[#F39200] transition-colors"
                (click)="togglePrincipalPasswordVisibility()"
              >
                <i
                  class="bi text-xl"
                  [ngClass]="hidePrincipalPassword ? 'bi-eye' : 'bi-eye-slash'"
                ></i>
              </button>
            </div>
            <div
              *ngIf="f['password'].invalid && (f['password'].touched || f['password'].dirty)"
              class="text-red-500 text-sm mt-2"
            >
              Le mot de passe est requis
            </div>

            <div class="text-right mt-3">
              <a
                [routerLink]="['/MotDePasseOublie']"
                class="text-[#F39200] hover:text-[#E68600] no-underline text-base transition-colors"
              >
                Mot de passe oublié ?
              </a>
            </div>
          </div>

          <!-- Submit Button -->
          <button
            type="submit"
            [disabled]="signInForm.invalid || isLoading"
            [ngClass]="{
              'bg-[#F39200] hover:bg-[#E68600]': signInForm.valid && !isLoading,
              'bg-gray-400 cursor-not-allowed': signInForm.invalid || isLoading
            }"
            class="w-full py-4 px-6 text-white border-none rounded-lg text-lg font-semibold cursor-pointer transition-all mt-8 flex items-center justify-center gap-3"
          >
            <!-- Loading Spinner -->
            <svg
              *ngIf="isLoading"
              class="slow-spin h-6 w-6 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4z"
              ></path>
            </svg>
            <span>{{ isLoading ? 'Connexion...' : 'Connexion' }}</span>
          </button>
        </form>
      </div>
    </div>

    <!-- Footer -->
    <div class="text-center text-[#F39200] text-base md:text-lg py-8 px-6 border-t border-gray-100">
      ONECI 2025 - Tous droits réservés
    </div>
  </div>
</div>

<!-- Password Change Modal -->
@if (showModal) {
<div class="fixed inset-0 z-[9999] flex items-center justify-center p-6 bg-black/50">
  <div class="relative bg-white w-full max-w-lg mx-4 shadow-xl rounded-lg overflow-hidden">
    <!-- Modal Header -->
    <div class="px-8 py-6 bg-gray-900 flex justify-between items-center">
      <h1 class="text-xl md:text-2xl font-semibold text-white">Modification du mot de passe</h1>
      <button (click)="closeModal()" class="text-white hover:text-[#F39200] transition-colors p-2">
        <i class="bi bi-x-lg text-xl md:text-2xl"></i>
      </button>
    </div>

    <!-- Modal Body -->
    <form [formGroup]="changePassword" (ngSubmit)="confirmSave()">
      <div class="p-8 space-y-6">
        <!-- Email Field (Disabled) -->
        <div class="form-group">
          <label class="block text-base md:text-lg font-medium text-gray-700 mb-2"> Email </label>
          <input
            formControlName="email"
            class="w-full h-12 border bg-gray-100 px-4 py-3 rounded-lg text-base"
            [disabled]="true"
          />
        </div>

        <!-- Old Password Field -->
        <div class="form-group">
          <label class="block text-base md:text-lg font-medium text-gray-700 mb-2">
            Ancien mot de passe <span class="text-red-500">*</span>
          </label>
          <div class="relative">
            <input
              [type]="hidePassword ? 'password' : 'text'"
              formControlName="oldMotDePasse"
              class="w-full h-12 border bg-white px-4 py-3 pr-12 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-[#F39200] focus:border-transparent"
              placeholder="Entrez votre ancien mot de passe"
            />
            <button
              type="button"
              class="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-600 hover:text-[#F39200] transition-colors"
              (click)="togglePasswordVisibility()"
            >
              <i class="bi text-xl" [ngClass]="hidePassword ? 'bi-eye-slash' : 'bi-eye'"></i>
            </button>
          </div>
        </div>

        <!-- New Password Field -->
        <div class="form-group">
          <label class="block text-base md:text-lg font-medium text-gray-700 mb-2">
            Nouveau mot de passe <span class="text-red-500">*</span>
          </label>
          <div class="relative">
            <input
              [type]="hideNewPassword ? 'password' : 'text'"
              formControlName="password"
              class="w-full h-12 border bg-white px-4 py-3 pr-12 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-[#F39200] focus:border-transparent"
              placeholder="Entrez votre nouveau mot de passe"
            />
            <button
              type="button"
              class="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-600 hover:text-[#F39200] transition-colors"
              (click)="toggleNewPasswordVisibility()"
            >
              <i class="bi text-xl" [ngClass]="hideNewPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="px-8 py-6 bg-gray-50 flex flex-col sm:flex-row justify-end gap-4 border-t">
        <button
          type="button"
          (click)="closeModal()"
          class="px-6 py-3 bg-gray-900 text-white rounded-lg hover:bg-gray-800 w-full sm:w-auto order-2 sm:order-1 transition-colors text-base font-medium"
        >
          Annuler
        </button>
        <button
          type="submit"
          class="px-6 py-3 bg-[#F39200] text-white rounded-lg hover:bg-[#E68600] w-full sm:w-auto order-1 sm:order-2 transition-colors text-base font-medium"
        >
          Enregistrer
        </button>
      </div>
    </form>
  </div>
</div>
}
